import { Loader2 } from "lucide-react";
import { Button as UIButton } from "@hotelise/ui";

import { ButtonSize } from "interfaces/buttons";

interface Props {
	title: string;
	disabled?: boolean;
	onClick?: () => void;
	type?: "button" | "submit" | "reset";
	light?: boolean;
	dark?: boolean;
	bold?: boolean;
	isLoading?: boolean;
	size: ButtonSize;
	icon?: React.ReactNode;
	className?: string;
}

const sizeMap: Record<ButtonSize, "default" | "sm" | "lg"> = {
	[ButtonSize.FULL_WIDTH]: "lg",
	[ButtonSize.LG]: "lg",
	[ButtonSize.MD]: "default",
	[ButtonSize.SM]: "sm",
	[ButtonSize.XS]: "sm",
};

const Button = (props: Props): JSX.Element => {
	const {
		title,
		onClick,
		disabled,
		type,
		light,
		isLoading,
		size,
		icon,
		className,
	} = props;

	const variant = light ? "outline" : "default";
	const uiSize = sizeMap[size];

	return (
		<UIButton
			onClick={onClick}
			disabled={disabled || isLoading}
			type={type || "button"}
			variant={variant}
			size={uiSize}
			className={`${size === ButtonSize.FULL_WIDTH ? "w-full" : ""} ${className || ""}`}
		>
			{isLoading ? (
				<Loader2 className="h-4 w-4 animate-spin" />
			) : (
				<>
					{icon}
					{title}
				</>
			)}
		</UIButton>
	);
};

export default Button;
